import Axios from 'axios'
import { checkBrowser } from '../channel/setUserChannel'
import { handleOptions } from '../handleOptions/fetchHelper'
import { Indicator, Toast } from 'mint-ui'
// eslint-disable-next-line camelcase
import signKey from '../sign/cryptoKey2'
import { encryptUserSign } from '../sign/user-sign'
import qs from 'qs'

console.log('signKey', signKey)
const axios = Axios.create({
  timeout: 10000,
  baseURL:
    process.env.VUE_APP_NODE_ENV === 'development'
      ? '/api'
      : process.env.VUE_APP_CLOUD_BASE_URL + process.env.VUE_APP_PROTOCOL_URL,
  transformRequest: [
    function (data, headers) {
      if (
        headers['Content-Type'] &&
        headers['Content-Type'].includes('application/x-www-form-urlencoded')
      ) {
        return qs.stringify(data)
      } else {
        if (!headers['Content-Type']) {
          headers['Content-Type'] = 'application/json'
        }
        return JSON.stringify(data)
      }
    }
  ]
})

// 自定义header
const headers = {
  'USER-CHANNEL': checkBrowser()
}

// function setToken (token) {
//   headers['AUTH-TOKEN'] = token
// }

function setUserSign (url, data = {}) {
  headers['USER-SIGN'] = encryptUserSign(url, data, signKey[0])
}

axios.interceptors.request.use(config => {
  if (config.hasOwnProperty('loading')) {
    config.loading.text
      ? Indicator.open({
        text: config.loading.text,
        spinnerType: config.loading.spinnerType
      })
      : Indicator.open()
  }

  return config
})

const successCode = ['000000', 'A00001']

axios.interceptors.response.use(
  async response => {
    Indicator.close()
    let { code } = response.data
    // eslint-disable-next-line no-undef
    if (!successCode.includes(code)) {
      Toast({
        message: response.data.msg || '出了点小差，请稍后再试',
        position: 'middle',
        duration: 2000
      })
    }
    return response
  },
  err => {
    // 这里最好resolve掉服务器错误这种情况，省得之后还要catch
    Indicator.close()
    return Promise.resolve(err)
  }
)

function customerizePost (options = {}) {
  console.log('options', options)
  setUserSign(options.url, options.data)
  const defaultConfig = {
    headers,
    method: 'post'
  }
  const data = options.data || {}
  if (options.data) {
    delete options.data
  }
  const config = handleOptions(defaultConfig, options)
  return axios({
    ...config,
    data
  })
    .then(res => {
      return res
    })
    .catch(err => {
      console.dir(err)
      return false
    })
}

export default {
  post: customerizePost
}
